import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { RioWebClientEventRequest } from '@chegg/rio-grpc-interfaces-web-client';
import { EVENT_REGISTERED_KEY, SEND_EVENT_LOGGING_KEY, Severity } from '../../types';
import anyproto from 'google-protobuf/google/protobuf/any_pb';
import { noWindow } from '../../utils';
import EnrichmentManager from '../../enrich/enrichManager';
import EventsQueue from '../../utils/EventsQueue';
import { captureError } from '../../utils/newRelicLogging';
var logMessageError = function logMessageError(errMsg) {
  var message = "error: ".concat(errMsg);
  captureError({
    error: message,
    location: SEND_EVENT_LOGGING_KEY,
    severity: Severity.ERROR
  }, {
    message: message
  });
};

// register event to kafka topic, first try with primary host name
// if fails, then try with secondary host name
export var sendGrpcEvent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var primaryRioWebClientEventServiceClient, secondaryRioWebClientEventServiceClient, enrichmentManager, eventType, eventData, req, eventDataSerialized, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          primaryRioWebClientEventServiceClient = _ref.primaryRioWebClientEventServiceClient, secondaryRioWebClientEventServiceClient = _ref.secondaryRioWebClientEventServiceClient, enrichmentManager = _ref.enrichmentManager, eventType = _ref.eventType, eventData = _ref.eventData;
          // creating a new rio web client request
          req = new RioWebClientEventRequest(); // apply all enrichments to the request
          enrichmentManager.applyEnrichers(req);
          req.setEventType(eventType);
          eventDataSerialized = new anyproto.Any();
          eventDataSerialized.pack(new Uint8Array(eventData), eventType);
          req.setEventData(eventDataSerialized);
          if (!primaryRioWebClientEventServiceClient) {
            _context.next = 32;
            break;
          }
          _context.prev = 8;
          _context.next = 11;
          return primaryRioWebClientEventServiceClient.sendWebEvent(req, {});
        case 11:
          response = _context.sent;
          _context.next = 30;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](8);
          if (!(_context.t0.message === '')) {
            _context.next = 20;
            break;
          }
          logMessageError("Error with \"\" while registering event to primaryRioWebClientEventServiceClient: ".concat(primaryRioWebClientEventServiceClient, " eventType: ").concat(eventType, " enrichmentManager: ").concat(JSON.stringify(enrichmentManager, null, ' '), " eventData: ").concat(JSON.stringify(eventData, null, ' ')));
          _context.next = 30;
          break;
        case 20:
          _context.prev = 20;
          if (!secondaryRioWebClientEventServiceClient) {
            _context.next = 25;
            break;
          }
          _context.next = 24;
          return secondaryRioWebClientEventServiceClient.sendWebEvent(req, {});
        case 24:
          response = _context.sent;
        case 25:
          _context.next = 30;
          break;
        case 27:
          _context.prev = 27;
          _context.t1 = _context["catch"](20);
          throw Error("Error while registering events to both the host names. primaryRioWebClientEventServiceClient: ".concat(primaryRioWebClientEventServiceClient, " secondaryRioWebClientEventServiceClient: ").concat(secondaryRioWebClientEventServiceClient, " eventType: ").concat(eventType, " enrichmentManager: ").concat(JSON.stringify(enrichmentManager, null, ' '), " eventData: ").concat(JSON.stringify(eventData, null, ' ')) + _context.t1);
        case 30:
          _context.next = 49;
          break;
        case 32:
          if (!secondaryRioWebClientEventServiceClient) {
            _context.next = 48;
            break;
          }
          _context.prev = 33;
          _context.next = 36;
          return secondaryRioWebClientEventServiceClient.sendWebEvent(req, {});
        case 36:
          response = _context.sent;
          _context.next = 46;
          break;
        case 39:
          _context.prev = 39;
          _context.t2 = _context["catch"](33);
          if (!(_context.t2.message === '')) {
            _context.next = 45;
            break;
          }
          logMessageError(_context.t2.message);
          _context.next = 46;
          break;
        case 45:
          throw Error("Error while registering events to both the host names. secondaryRioWebClientEventServiceClient: ".concat(secondaryRioWebClientEventServiceClient, " eventType: ").concat(eventType, " enrichmentManager: ").concat(JSON.stringify(enrichmentManager, null, ' '), " eventData: ").concat(JSON.stringify(eventData, null, ' '), ", primaryRioWebClientEventServiceClient is null") + _context.t2);
        case 46:
          _context.next = 49;
          break;
        case 48:
          throw Error("primaryRioWebClientEventServiceClient=null, secondaryRioWebClientEventServiceClient=null eventType: ".concat(eventType, " enrichmentManager: ").concat(JSON.stringify(enrichmentManager, null, ' '), " eventData: ").concat(JSON.stringify(eventData, null, ' '), ", primaryRioWebClientEventServiceClient is null"));
        case 49:
          if (response && response.getMessage() !== EVENT_REGISTERED_KEY) {
            logMessageError(response.getMessage());
          }
        case 50:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8, 14], [20, 27], [33, 39]]);
  }));
  return function sendGrpcEvent(_x) {
    return _ref2.apply(this, arguments);
  };
}();

// Consumer facing send event
/* eslint-disable */
var sendEvent = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(eventType, eventData, view) {
    var isRedirectInSameTabEvent,
      enrichmentManager,
      viewClone,
      eventsQueue,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          isRedirectInSameTabEvent = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
          if (noWindow()) {
            _context2.next = 11;
            break;
          }
          if (!window.rioClient2) {
            _context2.next = 7;
            break;
          }
          _context2.next = 5;
          return window.rioClient2.sendEvent(eventType, eventData, view, isRedirectInSameTabEvent);
        case 5:
          _context2.next = 11;
          break;
        case 7:
          enrichmentManager = new EnrichmentManager();
          if (view) {
            // view is passed by reference
            viewClone = _objectSpread({}, view);
            enrichmentManager.setViewProperties(viewClone);
          }
          eventsQueue = new EventsQueue();
          eventsQueue.add(eventType, eventData, enrichmentManager);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function sendEvent(_x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
/* eslint-enable */

export default sendEvent;